'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-3';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f0';
var svgPathData = ['M32 256a224 224 0 1 0 448 0 224 224 0 1 0 -448 0zm152-80c0-8.8 7.2-16 16-16l72 0c30.9 0 56 25.1 56 56 0 15.7-6.4 29.8-16.8 40 10.4 10.2 16.8 24.3 16.8 40 0 30.9-25.1 56-56 56l-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-8.8 0-16-7.2-16-16z', 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16-272l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0c30.9 0 56-25.1 56-56 0-15.7-6.4-29.8-16.8-40 10.4-10.2 16.8-24.3 16.8-40 0-30.9-25.1-56-56-56l-72 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle3 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;